/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // Switch collection grid layout
  window.addEventListener('load', function() {
    const changeViewWrapper = document.querySelector('.change-view-wrapper');

    if (changeViewWrapper) {
      // Switch collection grid layout
      const oneColumnBtn = document.getElementById('one-column-grid');
      const twoColumnBtn = document.getElementById('two-columns-grid');

      // Get the grid element
      const gridElement = document.getElementById('CollectionLoop');

      // Retrieve the selected view from Local Storage, if available
      const savedView = localStorage.getItem('selectedView');
      if (savedView === 'one') {
        gridElement.classList.add('grid-1');
        oneColumnBtn.classList.add('selected');
      } else if (savedView === 'two') {
        gridElement.classList.remove('grid-1');
        twoColumnBtn.classList.add('selected');
      }

      // Add event listeners to the buttons
      oneColumnBtn.addEventListener('click', () => toggleColumns('one'));
      twoColumnBtn.addEventListener('click', () => toggleColumns('two'));

      function toggleColumns(columns) {
        // Remove "selected" class from both buttons initially
        oneColumnBtn.classList.remove('selected');
        twoColumnBtn.classList.remove('selected');

        if (columns === 'two') {
          gridElement.classList.remove('grid-1');
          twoColumnBtn.classList.add('selected');
        } else if (columns === 'one') {
          gridElement.classList.add('grid-1');
          oneColumnBtn.classList.add('selected');
        }

        // Save the selected view to Local Storage
        localStorage.setItem('selectedView', columns);
      }
    }
  });

  // Edit gwstock iframe
  const addCssToGWStock = () => {
    // Edit gwstock iframe
    const iframeNotify = document.querySelector('#gw-stock-fulfilled-iframe');
    // console.log('iframeNotify', iframeNotify)
    if (iframeNotify) {
        const new_style_element = document.createElement('style');
        new_style_element.textContent = '.gw-branding-powered-by { display: none; } .email-input { border-radius: 0px; }';
        iframeNotify.contentDocument.head.appendChild(new_style_element);
    }
  }

  setTimeout(addCssToGWStock, 1000);
  setTimeout(addCssToGWStock, 3000);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
